<template src="./Modal.html"></template>
<script>
import { ICONOCERRAR, ICONOALERT, ICONOHECHO } from "./modal_consts";
import Icono from "../Icono/Icono";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      estadoModal: true,
      dialogoModal: false,
      dialog: false,
      iconoCerrar: ICONOCERRAR,
      iconoHecho: ICONOHECHO,
      iconoAlerta: ICONOALERT
    };
  },
  components: {
    Icono
  },
  created() {
    this.$emit("actualizarOpcion", "");
    // Tiempo para que el modal se cierre, y que cuando le de a la 'X' se resetee el setTimeout
    // this.$store.dispatch("setCargando", false);
    setTimeout(() => {
      if (this.estadoModal) {
        this.estadoModal = false;
        this.$store.dispatch("cambiarEstadoModal", false);
      }
    }, 10000);
  },
  methods: {
    cambiarEstadoModal(estado) {
      this.estadoModal = estado;
      this.$store.dispatch("cambiarEstadoModal", estado);
    },
    opcionSeleccionada(opcion) {
      this.$emit("actualizarOpcion", opcion);
      this.$store.dispatch("cambiarEstadoModal", false);
    }
  },
  computed: {
    cambiarMensajeModal() {
      if (this.$store.getters.getMensajeModal.dialogo) {
        this.dialogoModal = true;
      }
      return this.$store.getters.getMensajeModal;
    },
    cambiarIconoModal() {
      return this.$store.getters.getIconoModal;
    }
  }
};
</script>
<style lang="scss" scoped src="./Modal.scss"></style>
